module.exports = __webpack_public_path__ + "img/idea-bg.8f9f6f40.jpg";